import { BDM_TEAM_DIVISIONS } from './division'

// Division leaders whose Salesforce Contact does not carry the
// `Division_Leader__c` checkbox. Their reporting line still has to resolve, so
// team scoping treats them as managers and walks their `Manager__c` hierarchy.
//
// Backend mirror: HARD_CODED_LEADER_EMAILS in
// backend/src/services/pendingLeaveApprovals.js and HARDCODED_LEADERS in
// backend/src/services/division-leader.service.js.
export const HARDCODED_DIVISION_LEADERS = [
  'tuan@duotax.com.au',
  'kristian@duotax.com.au', // Kristian Sese
] as const

export const isHardcodedDivisionLeader = (email?: string | null): boolean => {
  if (!email) return false
  const candidate = email.trim().toLowerCase()
  return HARDCODED_DIVISION_LEADERS.some((leader) => leader === candidate)
}

// Custom team scoping: leaders who oversee a division + location pool that sits
// outside their `Manager__c` reporting line. Mirrors CUSTOM_TEAM_LEADERS in
// backend/src/routes/leave.js and backend/src/services/pendingLeaveApprovals.js,
// which already scope Kristian Sese's leave approvals this way.
//
// Kristian oversees the Philippines BDM group, which spans both
// "Business Development Manager" and "Sales". Several of those staff report to
// other managers in Salesforce, so the hierarchy alone does not reach them.
export interface CustomTeamScope {
  teams: readonly string[]
  location: string
}

export const CUSTOM_TEAM_LEADERS: Record<string, CustomTeamScope> = {
  'kristian@duotax.com.au': {
    teams: BDM_TEAM_DIVISIONS,
    location: 'Philippines',
  },
}

export const getCustomTeamScope = (email?: string | null): CustomTeamScope | undefined => {
  if (!email) return undefined
  return CUSTOM_TEAM_LEADERS[email.trim().toLowerCase()]
}

export const matchesCustomTeamScope = (
  scope: CustomTeamScope,
  team?: string | null,
  location?: string | null
): boolean => {
  if (!location || location.trim().toLowerCase() !== scope.location.toLowerCase()) return false
  const candidate = String(team || '')
    .trim()
    .toLowerCase()
  return scope.teams.some((entry) => entry.toLowerCase() === candidate)
}
